import React from "react";
import Reveal, { Eyebrow } from "../common/Reveal";
import { first60 } from "../../mock";

export default function First60() {
  return (
    <section className="bg-lybl-cream py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="text-center">
          <Reveal><Eyebrow>{first60.eyebrow}</Eyebrow></Reveal>
          <Reveal delay={80}><h2 className="mt-4 font-serif text-4xl lg:text-5xl text-lybl-ink">{first60.title}</h2></Reveal>
          <Reveal delay={140}><p className="mt-5 max-w-2xl mx-auto text-lybl-muted text-lg">{first60.subtitle}</p></Reveal>
        </div>

        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {first60.items.map((it, i) => (
            <Reveal key={it.title} delay={i * 80}>
              <div className="h-full rounded-2xl bg-white ring-1 ring-black/5 p-6">
                <span className="inline-block rounded-full bg-lybl-green/10 px-3 py-1 text-[13px] font-semibold text-lybl-green">{it.time}</span>
                <h3 className="mt-4 font-serif text-xl text-lybl-ink">{it.title}</h3>
                <p className="mt-2 text-[14px] text-lybl-muted leading-relaxed">{it.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
